import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchCurrentStep, fetchTabList } from "CourseAction";
import { fetchAllSpeakers } from "ActionsSpeakers";
import { fetchUserInterests } from "ActionsMessage";
import { fetchAllTickets } from "TicketAction";
import Navigation from "../wizard/navigation";
import CourseDetails from "./add-course-details";
import LessonsDetails from "./course-chapters-details";
import AddCoursePrice from "./add-course-price";
import PublishCourse from "./course-publish";
import LocaleStrings from "Languages";

class CourseNavigation extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let tabs = [
      { tab: "step_1", tabname: LocaleStrings.course_wizard_tab_1 },
      { tab: "step_2", tabname: LocaleStrings.course_wizard_tab_2 },
      { tab: "step_3", tabname: LocaleStrings.course_wizard_tab_4 },
      { tab: "step_4", tabname: LocaleStrings.course_wizard_tab_5 },
    ];
    this.props.fetchCurrentStep("step_1");
    this.props.fetchTabList(tabs);
    this.props.fetchAllSpeakers(this.props.session);
    this.props.fetchUserInterests(this.props.session);
    this.props.fetchAllTickets(this.props.session);
  }

  finishOperationsCallback = () => {
    this.props.finishOperationsCallback();
  };

  render() {
    let { courseWizardStep } = this.props;

    return (
      <div className="mt-10">
        <div className="row">
          <div className="col-md-12">
            <Navigation />
          </div>

          <div className="col-xl-9 col-lg-12 col-md-12">
            <div className="course-main-container">
              {courseWizardStep == "step_1" ? (
                <CourseDetails
                  callfrom="courses_list"
                  finishOperationsCallback={this.finishOperationsCallback}
                />
              ) : courseWizardStep == "step_2" ? (
                <LessonsDetails
                  source="main-page"
                  callfrom="courses_list"
                  finishOperationsCallback={this.finishOperationsCallback}
                />
              ) : courseWizardStep == "step_3" ? (
                <AddCoursePrice
                  callfrom="courses_list"
                  finishOperationsCallback={this.finishOperationsCallback}
                />
              ) : courseWizardStep == "step_4" ? (
                <PublishCourse
                  callfrom="courses_list"
                  finishOperationsCallback={this.finishOperationsCallback}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {

  return {
    session: state.session,
    courseWizardStep: state.courseWizardStep,
    allSpeakers: state.allSpeakers,
  };
}

export default connect(mapStateToProps, {
  fetchCurrentStep,
  fetchTabList,
  fetchAllSpeakers,
  fetchUserInterests,
  fetchAllTickets,
})(CourseNavigation);
